import { render, staticRenderFns } from "./QuickBet.vue?vue&type=template&id=3758d0e1"
import script from "./QuickBet.vue?vue&type=script&lang=js"
export * from "./QuickBet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports